import { httpClient } from 'shared/api/http-client'
import {
  UpdateUserDomainAccountSettingsPayload,
  UpdateUserSettingsPayload,
} from '../types/user-settings-interface'

export const USER_SETTINGS_API = '/api/settings/profile'

export const updateUserSettings = (
  data: UpdateUserSettingsPayload | UpdateUserDomainAccountSettingsPayload,
) => httpClient.patch(USER_SETTINGS_API, data)
